export default "__VITE_ASSET__cf4ba416__"